import LlmProvidersStore from "./LlmProviders/LlmProvidersStore";
import LlmRoutingStore from "./LlmRouting/LlmRoutingStore";
import LlmUsageStore from "./LlmUsage/LlmUsageStore";

const aiStoreList = [
  { name: "llmProvidersViewStore", store: LlmProvidersStore },
  { name: "llmRoutingStore", store: LlmRoutingStore },
  { name: "llmUsageStore", store: LlmUsageStore },
];

export default aiStoreList;
